import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import { Component, Inject, Input, PLATFORM_ID } from '@angular/core';

import { StorageKeyEnum } from '@app/core/enums/storage-key.enum';
import { ToolsHelper } from '@app/core/helpers/tools.helper';
import { UserModel } from '@app/core/models';
import { StorageService } from '@app/core/services';
import { APP_CONFIG, IAppConfig } from '@app/core/services/app.config';

enum ActiveMenuItemEnum {
  DEALS = 1,
  TICKETS,
  AUTH,
}

@Component({
  selector: 'app-wl-header',
  templateUrl: './wl-header.component.html',
  styleUrls: ['./header-btns.scss', './wl-header.component.scss'],
})
export class WlHeaderComponent {
  @Input() notMain = false;

  public readonly ToolsHelper = ToolsHelper;
  public readonly nowDate = new Date().toISOString();
  public readonly ActiveMenuItemEnum = ActiveMenuItemEnum;

  public activedMenuItem: ActiveMenuItemEnum | null;
  time = Date.now();
  mobileMenuShow = false;

  public readonly isBrowser: boolean;

  get user(): UserModel {
    return this.storageService.USER;
  }

  constructor(
    @Inject(APP_CONFIG) public readonly appConfig: IAppConfig,
    @Inject(DOCUMENT) private document: Document,
    @Inject(PLATFORM_ID) private readonly platformId: any,
    private storageService: StorageService,
  ) {
    this.isBrowser = isPlatformBrowser(this.platformId);
  }

  // ngOnInit(): void {}

  openMobileMenu(event: MouseEvent): void {
    event.preventDefault();
    this.activedMenuItem = null;
    this.mobileMenuShow = !this.mobileMenuShow;
  }

  toggleMenuHandler(val: boolean | void, item: ActiveMenuItemEnum): void {
    if (val == null) {
      this.activedMenuItem = item === this.activedMenuItem ? null : item;
    } else if (val === true) {
      this.activedMenuItem = item;
    } else {
      this.activedMenuItem = null;
    }
  }

  logout(): void {
    this.storageService.removeKey(StorageKeyEnum.USER);
    this.storageService.removeKey(StorageKeyEnum.TOKEN);
    this.storageService.removeKey(StorageKeyEnum.PLANS);
    this.storageService.removeKey(StorageKeyEnum.PROFILE);
    this.storageService.removeKey(StorageKeyEnum.MAP_TYPE);
    this.mobileMenuShow = false;
    this.document.location.reload();
  }
}
